import React, { Component } from 'react';
import TermsAndConditions from '../../components/TermsAndConditions';

export default class LegalDocumentTerms extends Component {
  render() {
    return (
      <div style={{ flex: 1, padding: '1rem 2rem 1.5rem 2rem' }}>
        <TermsAndConditions docType="TERMS" />
      </div>
    );
  }
}
